<div
  *ngrxLet="legalStandardBalance$ as legalStandardBalance"
  data-test="fertilization-legal-standards-balance"
>
  @if (legalStandardBalance) {
    <div class="flex--row flex--nowrap">
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'nFertilizer' | translate }}
          <span class="text--bold">
            &nbsp;({{ legalStandardBalance.nManureUsage | agrNumber: '1.0-0' }} /
            {{ legalStandardBalance.nManureLegalStandard | agrNumber: '1.0-0' }})
          </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          @if (legalStandardBalance.nManureBalance < 0) {
            <mat-icon class="text-color--warn">warning</mat-icon>
          }
          @if (legalStandardBalance.nManureBalance >= 0) {
            <mat-icon class="text-color--primary">check</mat-icon>
          }
          <span class="flex__child--auto"
            >&nbsp;{{ legalStandardBalance.nManureBalance | agrNumber: '1.0-0' }}</span
          >
        </div>
      </div>
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'phosphate' | translate }}
          <span class="text--bold">
            &nbsp;({{ legalStandardBalance.p2O5Usage | agrNumber: '1.0-0' }} /
            {{ legalStandardBalance.p2O5LegalStandard | agrNumber: '1.0-0' }})
          </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          @if (legalStandardBalance.p2O5Balance < 0) {
            <mat-icon class="text-color--warn">warning</mat-icon>
          }
          @if (legalStandardBalance.p2O5Balance >= 0) {
            <mat-icon class="text-color--primary">check</mat-icon>
          }
          <span class="flex__child--auto"
            >&nbsp;{{ legalStandardBalance.p2O5Balance | agrNumber: '1.0-0' }}</span
          >
        </div>
      </div>
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'nTotal' | translate }}
          <span class="text--bold">
            &nbsp;({{ legalStandardBalance.nTotalUsage | agrNumber: '1.0-0' }} /
            {{ legalStandardBalance.nTotalLegalStandard | agrNumber: '1.0-0' }})
          </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          @if (legalStandardBalance.nTotalBalance < 0) {
            <mat-icon class="text-color--warn">warning</mat-icon>
          }
          @if (legalStandardBalance.nTotalBalance >= 0) {
            <mat-icon class="text-color--primary">check</mat-icon>
          }
          <span class="flex__child--auto"
            >&nbsp;{{ legalStandardBalance.nTotalBalance | agrNumber: '1.0-0' }}</span
          >
        </div>
      </div>
      @if ((cropYear$ | async) >= 2023) {
        <div class="spacing--margin-right">
          <div class="text--label">
            {{ 'phosphateWCLessThan100' | translate }}
            <span class="text--bold">
              &nbsp;({{
                legalStandardBalance.p2O5UsageWithLowerWorkingCoefficient | agrNumber: '1.0-0'
              }}
              / {{ legalStandardBalance.p2O5LegalStandard | agrNumber: '1.0-0' }})
            </span>
          </div>
          <div class="flex--row flex--nowrap flex--align-center">
            @if (legalStandardBalance.p2O5BalanceWithLowerWorkingCoefficient < 0) {
              <mat-icon class="text-color--warn">warning</mat-icon>
            }
            @if (legalStandardBalance.p2O5BalanceWithLowerWorkingCoefficient >= 0) {
              <mat-icon class="text-color--primary">check</mat-icon>
            }
            <span class="flex__child--auto"
              >&nbsp;{{
                legalStandardBalance.p2O5BalanceWithLowerWorkingCoefficient | agrNumber: '1.0-0'
              }}</span
            >
          </div>
        </div>
      }
    </div>
  }
</div>
